export const EnvironmentAndPublicHealthSafety = {
  "label": "Environment And Public Health Safety",
  "value": [
    {
      "code": "JD-1500.9600",
      "keyword": "Wildlife Conservation"
    },
    {
      "code": "JD-1500.9600-980",
      "keyword": "Wildlife Shelters"
    },
    {
      "code": "JD-2000.4500",
      "keyword": "Litter Control"
    },
    {
      "code": "JP",
      "keyword": "Public Health"
    },
    {
      "code": "JP-1500",
      "keyword": "Communicable Disease Control"
    },
    {
      "code": "JP-1500.1700-150",
      "keyword": "COVID-19 Control"
    },
    {
      "code": "JP-1500.3000",
      "keyword": "Housing Arrangements for Health Care Workers\/Other Responders"
    },
    {
      "code": "JP-6500.1900",
      "keyword": "Environmental Hazards Information"
    },
    {
      "code": "JP-6500.1900-550",
      "keyword": "Mold Pollution Information"
    },
    {
      "code": "JP-6500.6480",
      "keyword": "Personal Service Health Inspections"
    },
    {
      "code": "JP-6500.6500",
      "keyword": "Pest Control Services"
    },
    {
      "code": "JR",
      "keyword": "Public Safety"
    },
    {
      "code": "JR-1800",
      "keyword": "Emergency Rescue"
    },
    {
      "code": "JR-1950",
      "keyword": "Fire Stations"
    },
    {
      "code": "JR-6000",
      "keyword": "911 Services"
    },
    {
      "code": "JR-8000.9500",
      "keyword": "Weather Reports"
    },
    {
      "code": "JR-8200.1500-100",
      "keyword": "Babysitting Instruction"
    },
    {
      "code": "JR-8200.1500-150",
      "keyword": "Child Care Provider Training"
    },
    {
      "code": "JR-8200.1980",
      "keyword": "Farm Safety Education"
    },
    {
      "code": "JR-8200.2000",
      "keyword": "Fire Prevention Information"
    },
    {
      "code": "JR-8200.2100",
      "keyword": "Firearm Safety Education"
    },
    {
      "code": "JR-8200.2350",
      "keyword": "Food Safety Education"
    },
    {
      "code": "JR-8200.3000",
      "keyword": "Household Safety Programs"
    },
    {
      "code": "JR-8200.3400",
      "keyword": "Internet Safety Education"
    },
    {
      "code": "JR-8200.6500",
      "keyword": "Personal Safety Education"
    },
    {
      "code": "JR-8200.8500-180",
      "keyword": "Driving Safety Education"
    },
    {
      "code": "JR-8200.9500-450",
      "keyword": "Lifeguard Training"
    },
    {
      "code": "JR-8400.1500",
      "keyword": "Child Passenger Safety Seats"
    },
    {
      "code": "JR-8400.8000",
      "keyword": "Smoke Alarms"
    },
    {
      "code": "LF-4900.4500",
      "keyword": "Lead Poisoning Screening"
    },
    {
      "code": "LH-2700.6500",
      "keyword": "Poison Control"
    },
    {
      "code": "TE-8800",
      "keyword": "Utility Line Location Information\/811 Services"
    },
    {
      "code": "TE-8920.6600",
      "keyword": "Recycling"
    },
    {
      "code": "TE-8920.7100-850",
      "keyword": "Trash\/Garbage Pickup"
    },
    {
      "code": "TE-8920.7200-550",
      "keyword": "Medication Disposal"
    },
    {
      "code": "TE-8920.7200-750",
      "keyword": "Sharps Disposal Programs"
    },
    {
      "code": "TE-8945",
      "keyword": "Water Well Construction Services"
    },
    {
      "code": "TH-1500.1600",
      "keyword": "County Offices of Emergency Services"
    },
    {
      "code": "TH-1500.1700",
      "keyword": "Disaster Relief\/Recovery Organizations"
    },
    {
      "code": "TH-1500.2000",
      "keyword": "Federal Emergency Management Agency Offices"
    },
    {
      "code": "TH-1500.8000",
      "keyword": "State Offices of Emergency Services"
    },
    {
      "code": "TH-1700.1800",
      "keyword": "Disaster Preparedness Information"
    },
    {
      "code": "TH-1700.1910-150.15",
      "keyword": "Community Emergency Response Team Program"
    },
    {
      "code": "TH-1700.6400-190",
      "keyword": "Disaster Kits"
    },
    {
      "code": "TH-1700.6400-950",
      "keyword": "Weather Alert Radios"
    },
    {
      "code": "TH-1800.1900-750",
      "keyword": "Sandbags\/Water Diversion Systems"
    },
    {
      "code": "TH-2100.1850",
      "keyword": "Evacuation Information"
    },
    {
      "code": "TH-2100.7000",
      "keyword": "Road Closures Bulletins"
    },
    {
      "code": "TH-2300.1200",
      "keyword": "Community Storm Shelters"
    },
    {
      "code": "TH-2300.1400",
      "keyword": "Emergency Communications"
    },
    {
      "code": "TH-2300.6350-200",
      "keyword": "Disaster Medical Assistance Teams"
    },
    {
      "code": "TH-2300.6370",
      "keyword": "Post Disaster Emergency Medical Equipment and Supplies"
    },
    {
      "code": "TH-2600.1500",
      "keyword": "Critical Service Status Information"
    },
    {
      "code": "TH-2600.1500-650",
      "keyword": "Open Gas Stations"
    },
    {
      "code": "TH-2600.1500-800",
      "keyword": "School Closures"
    },
    {
      "code": "TH-2600.1580-500",
      "keyword": "Mass Care Shelters"
    },
    {
      "code": "TH-2600.1600-170",
      "keyword": "Disaster Related Animal Shelters"
    },
    {
      "code": "TH-2600.1600-180",
      "keyword": "Disaster Related Livestock Evacuation and Sheltering Assistance"
    },
    {
      "code": "TH-2600.1800",
      "keyword": "Disaster Survivor Inquiries"
    },
    {
      "code": "TH-2600.1880",
      "keyword": "Extreme Cold Warming Centers"
    },
    {
      "code": "TH-2600.1900",
      "keyword": "Extreme Heat Cooling Programs"
    },
    {
      "code": "TH-2600.1900-180",
      "keyword": "Extreme Heat Cooling Centers"
    },
    {
      "code": "TH-2600.1930",
      "keyword": "Extreme Heat Hydration Stations"
    },
    {
      "code": "TH-2600.6450",
      "keyword": "Post Disaster Food Services"
    },
    {
      "code": "TH-2600.6450-195",
      "keyword": "Disaster Related Drinking Water"
    },
    {
      "code": "TH-2600.6450-500",
      "keyword": "Mass Feeding Services"
    },
    {
      "code": "TH-2600.6470",
      "keyword": "Tarps-Post Disaster Home Security Measures"
    },
    {
      "code": "TH-2600.6480",
      "keyword": "Post Disaster Immunizations"
    },
    {
      "code": "TH-2600.6500",
      "keyword": "Post Disaster Mental Health Services"
    },
    {
      "code": "TH-2900.1700-160",
      "keyword": "Disaster Donations Hotlines"
    },
    {
      "code": "TH-2900.1700-260",
      "keyword": "Disaster Related Goods Donations Management"
    },
    {
      "code": "TH-2900.1700-300",
      "keyword": "Disaster Related Monetary Fund Management"
    },
    {
      "code": "TH-2900.1750",
      "keyword": "Disaster Loans"
    },
    {
      "code": "TH-2900.1780",
      "keyword": "Disaster Related Case Management"
    },
    {
      "code": "TH-2900.1800-180",
      "keyword": "Disaster Recovery Centers"
    },
    {
      "code": "TH-2900.1800-200",
      "keyword": "FEMA Disaster Assistance Online\/Tele-Registration"
    },
    {
      "code": "TH-2900.1800-700",
      "keyword": "Red Cross Disaster Service Centers"
    },
    {
      "code": "TH-2900.6400-170",
      "keyword": "Disaster Related Debris Removal"
    },
    {
      "code": "TH-2900.6500",
      "keyword": "Post Disaster Housing Assistance"
    },
    {
      "code": "TH-2900.6500-600",
      "keyword": "Post Disaster Damage Reporting"
    },
    {
      "code": "TH-2900.8500",
      "keyword": "Spontaneous Volunteer Management"
    },
    {
      "code": "TI-1800.1500-180",
      "keyword": "Diaper Donation Programs"
    },
    {
      "code": "TI-1800.3000-250",
      "keyword": "General Household Goods Donation Programs"
    },
    {
      "code": "TI-1800.5000-230",
      "keyword": "General Medical Equipment\/Assistive Technology Donation Programs"
    },
    {
      "code": "TI-1800.9000",
      "keyword": "Vehicle Donation Programs"
    },
    {
      "code": "TI-1800.9000-080",
      "keyword": "Bicycle Donation Programs"
    },
    {
      "code": "TI-1900",
      "keyword": "Donation Drop Off Points"
    },
    {
      "code": "TI-2100",
      "keyword": "Donation Pickups"
    },
    {
      "code": "TJ-1800.6650",
      "keyword": "Public Access Computers\/Tools"
    },
    {
      "code": "TJ-3200.1600",
      "keyword": "Directory Assistance"
    },
    {
      "code": "TJ-3200.2500",
      "keyword": "Government Information Services"
    },
    {
      "code": "TJ-3200.2500-850",
      "keyword": "311 Services"
    },
    {
      "code": "TJ-5000",
      "keyword": "Maps"
    },
    {
      "code": "TJ-5500",
      "keyword": "Media\/Communications"
    },
    {
      "code": "TJ-8000.1500",
      "keyword": "Census Data"
    },
  ]
}
